import React from "react";

function WorkingHours() {
  return (
    <div className="footer__hours">
      <h4>Nuestros Horarios</h4>
      <ul>
        <li>
          <strong>Lun - Jue:</strong> 12:00PM - 11:00PM
        </li>
        <li>
          <strong>Vie - Dom:</strong> 11:00AM - 02:00AM
        </li>
      </ul>
    </div>
  );
}

export default WorkingHours;
